import { render } from "./ClientEventTimelineItemResubmissionDialog.vue?vue&type=template&id=caa7bc8c"
import script from "./ClientEventTimelineItemResubmissionDialog.vue?vue&type=script&lang=js"
export * from "./ClientEventTimelineItemResubmissionDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__